/**
 * IMPORTS
 */
class AppError extends Error {
  public readonly statusCode?: number;
  public readonly code?: string;
  public readonly status?: number;
  /** Corpo JSON da API quando o erro veio de uma resposta HTTP (ex.: 422). */
  public readonly responseData?: unknown;

  constructor(
    message: string,
    statusCode?: number,
    status?: number,
    code?: string,
    responseData?: unknown
  ) {
    super(message);
    this.name = "AppError";
    this.statusCode = statusCode;
    this.status = status;
    this.code = code;
    this.responseData = responseData;
  }
}

/**
 * EXPORTS
 */
export { AppError };
